<template>
  <loading-modal v-if="loading" :value="loading" :max-width="200" />
  <v-responsive class="mx-auto bg-white fill-height my-page" v-else>
    <div>
      <template v-if="bookingPaymentTransaction">
        <v-row align="center" justify="center" style="margin-top: 160px">
          <v-col cols="auto">
            <div v-if="bookingPaymentTransaction.statusCode === 'SUCCESS'">
              <v-img class="img-icon-status" :src="khSuccessIcon"></v-img>
            </div>
            <div v-else>
              <v-img class="img-icon-status" :src="khFaikIcon"></v-img>
            </div>
          </v-col>
          <v-col cols="12" class="text-center" style="margin-top: 36px">
            <div>
              <p class="fs-bold-28 color-primary ps-8 pe-8">
                {{ bookingPaymentTransaction?.titleTh }}
              </p>
              <p class="fs-bold-28 color-primary ps-8 pe-8">
                {{ bookingPaymentTransaction?.titleEn }}
              </p>
              <p class="fs-16 color-secondary mt-4 ps-8 pe-8">
                {{ bookingPaymentTransaction?.detailTh }}
              </p>
              <p class="fs-16 color-secondary mt-1 ps-8 pe-8">
                {{ bookingPaymentTransaction?.detailEn }}
              </p>
            </div>
          </v-col>
        </v-row>
        <p></p>
      </template>
    </div>
    <v-row
      class="bottom-button-container"
      v-if="bookingPaymentTransaction && bookingPaymentTransaction.buttonLink"
    >
      <v-col cols="12">
        <v-btn
          height="48"
          size="x-large"
          variant="outlined"
          elevation="0"
          style="
            color: white !important;
            background-color: #1b0081 !important;
            box-sizing: border-box !important;
          "
          class="border-8 full-width"
          @click="backToHistory(bookingPaymentTransaction.buttonLink)"
        >
          <p class="fs-16">กลับหน้าประวัติ / Back to Order History</p>
        </v-btn>
      </v-col>
    </v-row>
  </v-responsive>
</template>

<script>
import { mapGetters } from "vuex";
import khSuccessIcon from "@/assets/images/icons/kh_payment_success.png";
import khFaikIcon from "@/assets/images/icons/kh_payment_fail.png";
import { SHOP_PAYMENT_TRANSACTION_REQUEST } from "@/store/actions/shop";
import LoadingModal from "@/components/LoadingModal.vue";
// import { SHOP_INDEX } from "@/router/constant";

export default {
  components: { LoadingModal },
  computed: {
    ...mapGetters(["bookingPaymentTransaction"]),
  },
  data() {
    return {
      khSuccessIcon,
      khFaikIcon,
      bookingNo: null,
      loading: false,
    };
  },
  mounted() {
    this.$router.replace({
      name: this.$route.name,
      params: { bookingNo: undefined },
      query: {},
    });
  },
  async created() {
    try {
      this.loading = true;
      // this.bookingNo = this.$route.params.bookingNo;

      // await this.$store.dispatch(SHOP_PAYMENT_TRANSACTION_REQUEST, {
      //   bookingNo: this.bookingNo,
      // });

      await this.$store.dispatch(SHOP_PAYMENT_TRANSACTION_REQUEST);

      console.log("bookingPaymentTransaction", this.bookingPaymentTransaction);
      this.loading = false;
    } catch (error) {
      console.log(error);
      this.loading = false;
    }
  },
  methods: {
    backToHistory(link) {
      console.log("backToHistory", link);
      window.location.href = link;
    },
  },
};
</script>

<style scoped>
@font-face {
  font-family: "CustomerPageMainFont";
  src: url("@/assets/fonts/GraphikTH-Regular.ttf");
}

@font-face {
  font-family: "CustomerPageBoldFont";
  src: url("@/assets/fonts/GraphikTH-SemiBold.ttf");
}

.my-page {
  font-family: "CustomerPageMainFont" !important;
  scrollbar-width: none !important;
  -ms-overflow-style: none !important;
  top: 0;
  left: 0;
  overscroll-behavior: none !important;
  touch-action: none !important;
  overflow: hidden !important;
  position: fixed !important;
  width: 100%;
  height: 100dvh;
}

.my-page::-webkit-scrollbar {
  display: none !important;
  width: 0 !important;
  height: 0 !important;
}

.my-page p {
  margin-bottom: 0 !important;
}

.img-icon-status {
  width: 118px;
  height: 93.6px;
}

.bottom-button-container {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background-color: white;
  padding-left: 16px;
  padding-right: 16px;
  padding-bottom: 48px;
  box-sizing: border-box;
  transform: translateZ(0);
  will-change: transform;
}

.full-width {
  width: 100%;
}

.border-8 {
  border-radius: 8px !important;
}

.fs-bold-28 {
  font-size: 28px !important;
  font-weight: 500 !important;
  letter-spacing: -0.016rem !important;
  text-transform: none !important;
  line-height: 1.65 !important;
  font-family: "CustomerPageBoldFont" !important;
}

.fs-16 {
  font-size: 16px !important;
  letter-spacing: 0 !important;
  text-transform: none !important;
  line-height: 1.65 !important;
  font-family: "CustomerPageMainFont" !important;
}

/* .fill-height {
  height: 100dvh;
} */
</style>
